import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-9a080b22")
const _hoisted_1 = { class: "update-record-container" }
const _hoisted_2 = { class: "upload" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "+", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "type" }, "农事类型", -1)
const _hoisted_6 = { class: "content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "type" }, "农事名称", -1)
const _hoisted_8 = { class: "content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "type" }, "所在地块", -1)
const _hoisted_10 = { class: "right-content" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "type" }, "干活时间", -1)
const _hoisted_12 = { class: "date" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "type" }, "是否同步发布动态", -1)
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "menu-text" }
const _hoisted_16 = { class: "bottom-btn" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_stcp_h5_uploader = _resolveComponent("stcp-h5-uploader")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_switch = _resolveComponent("van-switch")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_preview_video = _resolveComponent("preview-video")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_picker = _resolveComponent("van-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_field, {
      modelValue: _ctx.message,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.message = $event)),
      rows: "3",
      autosize: "",
      type: "textarea",
      placeholder: "说说这次做的什么农活...",
      border: false,
      "show-word-limit": "",
      maxlength: 255
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isUpload && _ctx.fileList.length)
        ? (_openBlock(), _createBlock(_component_stcp_h5_uploader, {
            key: 0,
            modelValue: _ctx.fileList,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileList = $event)),
            "after-read": _ctx.afterUpload,
            "before-read": _ctx.onBeforeUpload,
            accept: _ctx.accept,
            "max-count": _ctx.uploadFileCount,
            onDelete: _ctx.onDeleteFile,
            onPoster: _ctx.onShowFile,
            multiple: ""
          }, null, 8, ["modelValue", "after-read", "before-read", "accept", "max-count", "onDelete", "onPoster"]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "upload-card",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickUpload && _ctx.onClickUpload(...args)))
          }, _hoisted_4))
    ]),
    (_ctx.dataInfo.farmingType)
      ? (_openBlock(), _createBlock(_component_van_cell, { key: 0 }, {
          icon: _withCtx(() => [
            _createVNode(_component_van_image, {
              class: "type-icon",
              src: "https://qnui.xfarmer.com/xfarmer-ui/h5Purchase/leixing.png"
            })
          ]),
          title: _withCtx(() => [
            _hoisted_5
          ]),
          value: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.dataInfo.farmingTypeName), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.dataInfo.farmingType)
      ? (_openBlock(), _createBlock(_component_van_cell, { key: 1 }, {
          icon: _withCtx(() => [
            _createVNode(_component_van_image, {
              class: "type-icon",
              src: "https://qnui.xfarmer.com/xfarmer-ui/h5Purchase/mingcheng.png"
            })
          ]),
          title: _withCtx(() => [
            _hoisted_7
          ]),
          value: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.dataInfo.plantFarmingName || _ctx.dataInfo.farmingName), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_van_cell, null, {
      icon: _withCtx(() => [
        _createVNode(_component_van_image, {
          class: "type-icon",
          src: "https://qnui.xfarmer.com/xfarmer-ui/h5Purchase/dikuai.png"
        })
      ]),
      title: _withCtx(() => [
        _hoisted_9
      ]),
      value: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", {
            class: _normalizeClass({ content: true, date: !_ctx.dataInfo.farmingType }),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSelectLand && _ctx.onSelectLand(...args)))
          }, "#" + _toDisplayString(_ctx.dataInfo.areaCode) + _toDisplayString(_ctx.dataInfo.areaName), 3),
          (!_ctx.dataInfo.farmingType)
            ? (_openBlock(), _createBlock(_component_van_image, {
                key: 0,
                class: "more",
                src: "https://qnui.xfarmer.com/xfarmer-ui/h5Purchase/right.png"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_van_cell, null, {
      icon: _withCtx(() => [
        _createVNode(_component_van_image, {
          class: "type-icon",
          src: "https://qnui.xfarmer.com/xfarmer-ui/h5Purchase/shijian.png"
        })
      ]),
      title: _withCtx(() => [
        _hoisted_11
      ]),
      value: _withCtx(() => [
        _createElementVNode("div", {
          class: "right-content",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSelectDate && _ctx.onSelectDate(...args)))
        }, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.dataInfo.workTime), 1),
          _createVNode(_component_van_image, {
            class: "more",
            src: "https://qnui.xfarmer.com/xfarmer-ui/h5Purchase/right.png"
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_van_cell, null, {
      icon: _withCtx(() => [
        _createVNode(_component_van_image, {
          class: "type-icon",
          src: "https://qnui.xfarmer.com/xfarmer-ui/h5Purchase/dikuai.png"
        })
      ]),
      title: _withCtx(() => [
        _hoisted_13
      ]),
      value: _withCtx(() => [
        _createVNode(_component_van_switch, {
          modelValue: _ctx.isCircle,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isCircle = $event)),
          onChange: _ctx.switchChange,
          "active-color": "#46d1af",
          "inactive-color": "#dcdee0",
          size: "1.2rem"
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_van_action_sheet, {
      show: _ctx.showUploadWay,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (_ctx.showUploadWay = $event)),
      "cancel-text": "取消",
      "close-on-click-action": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
          { id: 0, name: '照片' },
          { id: 1, name: '视频' },
        ], (item) => {
          return _createElementVNode("div", {
            class: "way-item",
            key: item.id,
            onClick: ($event: any) => (_ctx.onSelectWay(item))
          }, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(item.name), 1),
            _createVNode(_component_stcp_h5_uploader, {
              modelValue: _ctx.fileList,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.fileList = $event)),
              "after-read": _ctx.afterUpload,
              "before-read": _ctx.onBeforeUpload,
              accept: _ctx.accept,
              "max-count": _ctx.uploadFileCount,
              multiple: ""
            }, null, 8, ["modelValue", "after-read", "before-read", "accept", "max-count"])
          ], 8, _hoisted_14)
        }), 64))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_preview_video, {
      visible: _ctx.previewVideos,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.previewVideos = $event)),
      autoplay: "",
      url: _ctx.fileList.length > 0 ? _ctx.fileList[0].url : ''
    }, null, 8, ["visible", "url"]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", {
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)))
      }, "保存")
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showWorkDate,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => (_ctx.showWorkDate = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: _ctx.workDate,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.workDate = $event)),
          type: "date",
          title: "选择干活日期",
          "min-date": _ctx.minDate,
          "max-date": _ctx.maxDate,
          onCancel: _ctx.onWorkCancel,
          onConfirm: _ctx.onWorkConfirm
        }, null, 8, ["modelValue", "min-date", "max-date", "onCancel", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showLandModal,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => (_ctx.showLandModal = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "选择地块",
          columns: _ctx.sourceLandList,
          onConfirm: _ctx.onLandConfirm,
          onCancel: _ctx.onLandCancel
        }, null, 8, ["columns", "onConfirm", "onCancel"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}